export const status = [
  "active",
  "canceled",
  "trialing",
  "unpaid",
  "incomplete",
  "incomplete_expired",
  "past_due",
];
